module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 127
// module chunks = 1